const API_END_POINTS = {
  GET_DRIVER: 'drivers',
  GET_DELIVERIES_DAYS: 'producers/distinct-shipping-dates',
  GET_SHIPPINGS: 'orders/shippings/list',
  GET_DELIVERY_ORDER: 'orders/{id}/delivery',
};

export default API_END_POINTS;
